import { render, staticRenderFns } from "./Hxpcrktj.vue?vue&type=template&id=885d584e&scoped=true&"
import script from "./Hxpcrktj.vue?vue&type=script&lang=js&"
export * from "./Hxpcrktj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885d584e",
  null
  
)

export default component.exports